import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthorizationService} from '../modules/shared/service/authorization.service';
import {RedirectService} from "../modules/shared/service/redirect.service";

@Injectable()
export class LoggedInGuard implements CanActivate {

  constructor(
      private router: Router,
      private authService: AuthorizationService,
      private redirect: RedirectService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isUserLoggedIn()) {
      this.remember(route);
      this.router.navigateByUrl(this.router.createUrlTree(['login'], {queryParams: route.queryParams}));
    } else {
      return true;
    }
  }

  private remember(route: ActivatedRouteSnapshot) {
    if (route.data.returnAfterLogin ) {
      console.log('Route want to be reinstated after login', location.pathname);
      this.redirect.remember(location.pathname);
    }
  }
}